var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TreeView',{attrs:{"items":_vm.localCustomers,"load-children":_vm.loadChildren,"leaf-level":2},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }